module.exports = __webpack_public_path__ + "static/media/lm.018c0bf5.svg";